const prodConfigs = {
  apiUrl: "https://poc-api.core-ai.io",
  appHeader: "Optimal Dynamics - ",
  env: "prod",
  domain: "core-ai.io",
  reportDetailAPIMaxAttempt: 20,
  reportDetailAPIInterval: 30000,
};

export default prodConfigs;